// *********************************
// CoolGames Builder JavaScript file
// *********************************
import { ComponentBase } from "../../framework/components/ComponentBase";
import { ComponentContainer } from "../../framework/components/ComponentContainer";
import { ComponentPicture } from "../../framework/components/ComponentPicture";
import { tgfComponents } from "../../framework/components/tgfComponents";
import { tgfSettings } from "../../framework/tgfSettings";
import { PowerUpSettings } from "../../settings/Settings";
import { AngryAnalytics } from "../Analytics/Analytics";
import { s_buttonpowerbg, s_buttonpower_disabled, s_buttonpower_glow, s_buttonpower_effect, s_redcross } from "../AssetDefinitions/ImageDefinitions";
tgfSettings.componentDefaults.PowerUpSlotComponent =
    {
        x: 0, y: 0,
        onUsePowerUpClicked: null,
        components: []
    };
export var PowerUpSlot = function (properties) {
    'use strict';
    this.name = 'PowerUpSlotComponent';
    this.slotContainer = new ComponentContainer();
    this.initialize(tgfSettings.componentDefaults.PowerUpSlotComponent);
    this._powerUpImages = [];
    this.isSelected = false;
    for (var a in properties) {
        this[a] = properties[a];
    }
    this._previousPowerUp = -1;
};
// Inherit the base component
tgfComponents.inherit(PowerUpSlot, ComponentBase);
/**
 * The index of the slot
 */
PowerUpSlot.prototype._slotIndex = -1;
PowerUpSlot.prototype._powerUpIndex = -1;
PowerUpSlot.prototype.showPowerUp = function (powerUpIndex) {
    "use strict";
    if (powerUpIndex < 0) {
        return;
    }
    this._powerUpIndex = powerUpIndex;
    if (this._previousPowerUp > -1) {
        this._powerUpImages[this._previousPowerUp].setAlpha(0);
    }
    //this.powerUpSlotBG2.setAlpha(0);
    this._disabledPowerUpIcon.setAlpha(0);
    if (powerUpIndex >= 0) {
        this._powerUpImages[powerUpIndex].setAlpha(1);
    }
    for (var index = 0; index < this._powerUpGlowEffects.length; index++) {
        var element = this._powerUpGlowEffects[index];
        element.setAlpha(0.4);
    }
    for (var prop in this.powerUpSlotBG2Map) {
        this.powerUpSlotBG2Map[prop].setAlpha(0);
    }
    this.powerUpSlotBG2Map[PowerUpSettings.options[this._powerUpIndex].bgImg.name].setAlpha(1);
    this._previousPowerUp = powerUpIndex;
};
PowerUpSlot.prototype._enableInput = function () {
    this.disabled = false;
};
PowerUpSlot.prototype._disableInput = function () {
    this.disabled = true;
};
// Processing required when preparing the component for use
PowerUpSlot.prototype.doPrepare = function () {
    "use strict";
    var i, self = this;
    this._previousPowerUp = this._powerUpIndex;
    var powerUpSlotBG1 = new ComponentPicture({
        image: s_buttonpowerbg,
        xScale: 1.07,
        yScale: 1.07
    });
    // This code basically goes through the powerup settings and collects a list of all used unique bgImgs
    var flags = [];
    this.powerUpBGs = [];
    for (i = 0; i < PowerUpSettings.options.length; i++) {
        if (flags[PowerUpSettings.options[i].bgImg.name]) {
            continue; // If already collected this bgimg then ignore
        }
        flags[PowerUpSettings.options[i].bgImg.name] = true; // Mark this BG as already loaded
        this.powerUpBGs.push(PowerUpSettings.options[i].bgImg); // Push it to the array
    }
    this.powerUpSlotBG2Map = [];
    for (var index = 0; index < this.powerUpBGs.length; index++) {
        var element = this.powerUpBGs[index];
        this.powerUpSlotBG2Map[element.name] = (new ComponentPicture({
            image: element,
            x: -0,
            y: -8,
            alpha: 0,
            xScale: 1.1,
            yScale: 1.1
        }));
    }
    this.powerUpSlotBG2Map["s_buttonpower_disabled.png"] = (new ComponentPicture({
        image: s_buttonpower_disabled,
        alpha: 0,
        xScale: 1.1,
        yScale: 1.1
    }));
    if (this._powerUpIndex >= 0) {
        this.powerUpSlotBG2Map[PowerUpSettings.options[this._powerUpIndex].bgImg.name].alpha = 1;
    }
    else {
        this.powerUpSlotBG2Map["s_buttonpower_disabled.png"].alpha = 1;
    }
    for (var prop in this.powerUpSlotBG2Map) {
        powerUpSlotBG1.addComponent(this.powerUpSlotBG2Map[prop]);
    }
    this._powerUpGlowEffects = [];
    var powerUpSlotGlow = new ComponentPicture({
        image: s_buttonpower_glow,
        xScale: 1,
        yScale: 1,
        alpha: (this._powerUpIndex >= 0) ? 0.3 : 0
    });
    this._powerUpGlowEffects.push(powerUpSlotGlow);
    powerUpSlotBG1.addComponent(powerUpSlotGlow);
    var powerUpSlotEffect = new ComponentPicture({
        image: s_buttonpower_effect,
        xScale: 0.75,
        yScale: 0.75,
        alpha: (this._powerUpIndex >= 0) ? 0.4 : 0
    });
    this._powerUpGlowEffects.push(powerUpSlotEffect);
    powerUpSlotBG1.addComponent(powerUpSlotEffect);
    for (i = 0; i < PowerUpSettings.options.length; i++) {
        var picture = new ComponentPicture({
            image: PowerUpSettings.options[i].image,
            xScale: 1,
            yScale: 1,
            x: -PowerUpSettings.options[i].iconOffset.x,
            y: -PowerUpSettings.options[i].iconOffset.y,
            alpha: (this._powerUpIndex === i) ? 1 : 0,
            onClick: function () {
                self.onPowerupClick();
            }
        });
        this._powerUpImages.push(picture);
        powerUpSlotBG1.addComponent(picture);
    }
    this.slotContainer.addComponent(powerUpSlotBG1);
    this.redCross = new ComponentPicture({
        image: s_redcross,
        alpha: 0
    });
    this.slotContainer.addComponent(this.redCross);
    this.addComponent(this.slotContainer);
    // Add the child components
    if (this.components) {
        for (i = 0; i < this.components.length; i += 1) {
            this.addComponent(this.components[i]);
        }
    }
};
PowerUpSlot.prototype.onPowerupClick = function () {
    if (this._disabled === true) {
        return;
    }
    if (this.isCancelingPowerup()) {
        return;
    }
    if (this.isSelected) {
        this.onCancelSelection();
    }
    else {
        if (this._powerUpIndex < 0) {
            return;
        }
        if (this.onUsePowerUpClicked(PowerUpSettings.options[this._powerUpIndex].kind, this._slotIndex)) {
            this.onSelection();
        }
    }
};
PowerUpSlot.prototype.onCancelSelection = function () {
    this.setScale(1 / PowerUpSettings.selectedPowerUpIconScale, 1 / PowerUpSettings.selectedPowerUpIconScale);
    this.onCancelPowerup();
    this.redCross.setAlpha(0);
    this.isSelected = false;
};
PowerUpSlot.prototype.onRefill = function (powerUp) {
    this.setPowerUpIndex(powerUp);
    for (var i = 0; i < this._powerUpImages.length; i++) {
        this._powerUpImages[i].setAlpha(0);
    }
    for (var i = 0; i < PowerUpSettings.options.length; i++) {
        this.powerUpSlotBG2Map[PowerUpSettings.options[i].bgImg.name].setAlpha(0);
    }
    this.powerUpSlotBG2Map["s_buttonpower_disabled.png"].setAlpha(0);
    this._powerUpImages[this._powerUpIndex].setAlpha(1);
    this.powerUpSlotBG2Map[PowerUpSettings.options[this._powerUpIndex].bgImg.name].setAlpha(1);
};
PowerUpSlot.prototype.onCancelRefill = function () {
    this.onCancelPowerup();
    this.redCross.setAlpha(0);
    this.isSelected = false;
};
PowerUpSlot.prototype.onSelection = function () {
    this.redCross.setAlpha(1);
    AngryAnalytics.reportPowerupTapped();
    this.setScale(PowerUpSettings.selectedPowerUpIconScale, PowerUpSettings.selectedPowerUpIconScale);
    this.isSelected = true;
};
PowerUpSlot.prototype.animate = function () {
    'use strict';
    for (var index = 0; index < this._powerUpGlowEffects.length; index++) {
        var element = this._powerUpGlowEffects[index];
        element.setAngle(element.angle + 0.005);
    }
    var s = Math.sin(Date.now() * (0.001 * 1)) * 0.5 + 2.5;
    this.startGlow.setScale(s, s);
};
PowerUpSlot.prototype.setPowerUpIndex = function (powerUpIndex) {
    'use strict';
    this._powerUpIndex = powerUpIndex;
};
PowerUpSlot.prototype.setIndex = function (index) {
    this._slotIndex = index;
};
PowerUpSlot.prototype.getPowerUpIndex = function () {
    'use strict';
    return this._powerUpIndex;
};
PowerUpSlot.prototype.setScale = function (xS, yS) {
    'use strict';
    for (var index = 0; index < this._components.length; index++) {
        var element = this._components[index];
        this._scaleChildren(element, xS, yS);
    }
};
PowerUpSlot.prototype._scaleChildren = function (child, xS, yS) {
    'use strict';
    if (!child._components) {
        return;
    }
    for (var index = 0; index < child._components.length; index++) {
        var element = child._components[index];
        if (element.setScale) {
            element.setScale(element.xScale * xS, element.yScale * yS);
        }
        else {
            element.xScale = (element.xScale * xS);
            element.yScale = (element.yScale * yS);
        }
        if (element.image) {
            element.image.setScale(element.xScale, element.yScale);
        }
        this._scaleChildren(element, xS, yS);
    }
};
PowerUpSlot.prototype.setPosition = function (x, y) {
    'use strict';
    this.slotContainer.setPosition(x, y);
};
